'use strict';

let cloud = {};

const jQuery = require('jquery');

// prevent error on handlebars with webpack
cloud.handlebars = require(__dirname + '/../node_modules/handlebars/runtime');
cloud.jQuery = jQuery;

require('jquery-ui/ui/widgets/sortable');

cloud.mediator = require('./core/mediator');
cloud.container = require('./core/container');
cloud.requestHandler = require('./core/requestHandler');
cloud.translator = require('./core/translator');
cloud.alert = require('./services/alert');
cloud.auth = require('./services/auth');
cloud.fixHeight = require('./services/fixHeight');
cloud.flashMessage = require('./services/flashMessage');
cloud.formBuilder = require('./services/form');
cloud.elementClass = require('./services/form/elementClass');
cloud.loader = require('./services/loader');
cloud.notifier = require('./services/notifier');
cloud.popinManager = require('./services/popin');
cloud.zone = require('./services/structure/zone');
cloud.menu = require('./services/structure/menu');

cloud.userPrefRepository = require('./bundles/content/repository/UserPreferenceRepository');
cloud.contentRepository = require('./bundles/content/repository/ContentRepository');
cloud.dndZone = require('./bundles/content/service/dndZone');
cloud.resizeColumn = require('./bundles/content/service/resizeColumn');
cloud.pageRepository = require('./bundles/page/repository/page');
cloud.tagRepository = require('./bundles/tag/repository/TagRepository');
cloud.langRepository = require('./bundles/user/repository/LangRepository');
cloud.userRepository = require('./bundles/user/repository/UserRepository');

cloud.addContent = require('./bundles/content/listener/addContent');
cloud.imageCrop = require('./bundles/content/service/imageCrop');
cloud.imagePlaceholder = require('./bundles/content/service/imagePlaceholder');
cloud.textPlaceholder = require('./bundles/content/service/textPlaceholder');
cloud.saveManager = require('./bundles/content/component/SaveManager');
cloud.definitionManager = require('./bundles/content/component/DefinitionManager');
cloud.uploader = require('./bundles/content/service/uploader');
cloud.dropzone = require('./bundles/content/service/dropzone');
cloud.bundle = require('./bundles/bundle');

cloud.enableUi = () => {
    cloud.mediator.publish('ui-enabled');
};
cloud.disableUi = () => {
    cloud.mediator.publish('ui-disabled');
};
cloud.enableDnd = () => {
    cloud.mediator.publish('ui-enable-dnd');
};
cloud.disableDnd = () => {
    cloud.mediator.publish('ui-disable-dnd');
};
cloud.disableInsertContent = () => {
  cloud.mediator.publish('ui-insert-content-disabled');
};
cloud.enableDndOnlyHorizontalBetweenContent = () => {
  cloud.mediator.publish('ui-enable-dnd-only-horizontal-between-content');
};
cloud.disablePublishBtn = () => {
   jQuery('#cloud-nav-submit').children('li').addClass('d-none');
};
cloud.disablePageParametersBtn = () => {
    jQuery('#cloud-nav-primary').find('i.icon-page-parameters').parents('li:first').addClass('d-none');
};
cloud.enablePublishBtn = () => {
    jQuery('#cloud-nav-submit').children('li').removeClass('d-none');
};
cloud.enablePageParametersBtn = () => {
    jQuery('#cloud-nav-primary').find('i.icon-page-parameters').parents('li:first').removeClass('d-none');
};

window.cloud = cloud;
module.exports = cloud;
